import { styled } from '../../config/Theme';
import Size from '../../utils/Size';
import Card from './Card';

export default styled(Card)<Size>`
  width: calc(${(props) => props.width} - ${(props) => props.theme.space.small} * 2);
  height: calc(${(props) => props.height} - ${(props) => props.theme.space.small} * 2);
`;
